import { render } from "./Wishlist.vue?vue&type=template&id=8f6d960a&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import "./Wishlist.vue?vue&type=style&index=0&id=8f6d960a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6d960a"]])

export default __exports__